module.exports = {
  prefix: "usa",
};
